<template>
  <file-list></file-list>
</template>
<script>
import fileList from '../../components/FileList.vue'
export default {
  created () {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  components: {
    fileList
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/netDisk/TagFile.vue